const STORE = 'common/queryParams/STORE';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case STORE:
      return action.query;
    default:
      return state;
  }
}

export function setQuery(query) {
  return {
    query,
    type: STORE
  };
}



// WEBPACK FOOTER //
// ./modules/Common/reducers/queryParams.js